import React from 'react';
import { Stack, StackProps } from '@cp/ds/src/components/stack';
import { Typography } from '@cp/ds/src/components/typography';
import { Button } from '@cp/ds/src/components/button';
import { InfoIcon } from '@cp/ds/src/icons';

export interface SafetyLabelsProps extends StackProps {
  onClick?: () => void;
  isDocumentsChecked?: boolean;
}
export const SafetyLabels: React.FC<SafetyLabelsProps> = ({ isDocumentsChecked, onClick, sx, ...props }) => {
  return (
    <Stack
      {...(props as any)}
      component="ul"
      direction="column"
      gap={1}
      sx={{
        listStyleType: 'none',
        paddingInlineStart: 0,
        marginBlockStart: 0,
        marginBlockEnd: 0,
        ...sx,
      }}
    >
      {isDocumentsChecked && <Typography component="li">💡 Паспорт подтвержден</Typography>}
      <Typography component="li">📞 Телефон подтвержден</Typography>
      <Typography component="li" sx={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
        👮 Проверка благонадежности
        <Button onClick={onClick} variant="text">
          <InfoIcon />
        </Button>
      </Typography>
    </Stack>
  );
};
